import {CustomModal} from "./addAddressModal.style";
import {memo, useState} from "react";
import {activateNotification} from "../../../utils/notifications-utils";
import {useApi} from "../../../hooks/api.hook";
import {isAxiosError} from "axios";
import {AddUserAddressForm} from "../forms/addUserAddressForm";
import {ModalHeader} from "reactstrap";
import {CloseGrayedIcon} from "../../../assets/icons/close";
import {Mixpanel} from "../../../utils/mixpanel";

export const AddAddressModalComponent = memo(({setAddresses, isOpen, toggle}) => {
    const [loading, setLoading] = useState(false);
    const [responseErrors, setResponseErrors] = useState([]);

    const api = useApi()

    const onSubmit = async (data) => {
        Mixpanel.track("Generic-AddressesScreen-AddressAdded")
        setLoading(true)
        try {
            const {data: respData} = await api.post("/address", data)
            setAddresses((prevState) => [...prevState, respData.address])
            activateNotification({title: "Success", body: "Information updated"});
            toggle();
        } catch (e) {
            let errorMessage = "Failed to update info";
            if (isAxiosError(e)) {
                const data = e.response?.data;

                if (data?.errors && typeof data.errors === "object") {
                    setResponseErrors(data.errors);
                } else {
                    errorMessage = data?.message || e.message || errorMessage;
                }
            } else {
                errorMessage = e.message || errorMessage;
            }
            activateNotification({title: "Error", body: errorMessage});

        } finally {
            setLoading(false);
        }
    };

    return (<CustomModal fullscreen={"md"} isOpen={isOpen} toggle={toggle}>
        <ModalHeader>
            <div className="close-btn" onClick={toggle}>
                <CloseGrayedIcon/>
            </div>
            <span>
            Add Delivery Address
            </span>
        </ModalHeader>
        <hr className="custom-divider"/>
        <AddUserAddressForm onSubmit={onSubmit} loading={loading} responseErrors={responseErrors}/>
    </CustomModal>);
});
